/**
 * Add your theme constants  here.
 * @module constants/Theme
 * @example
 * export const UPDATE_CONTENT = 'UPDATE_CONTENT';
 */

export const MAP_DEFAULT_EXTENT = [818354.918, 5425389.1889, 1816693.282, 6070039.437];
